import {Redirect} from '@reach/router';
import React from 'react';

const Navigate = React.memo(({route}) => {
  return <Redirect to={route} noThrow />;
});

export default Navigate;
